import React, { useRef } from "react";
import { motion } from "framer-motion";
import personagens from "../../assets/images/personagens_tutorial.png";
import { Link } from "react-router-dom";
import backgroundImage from "../../assets/images/background.webp"; // Importando imagem

const LandingPage = () => {
  const sectionRefs = useRef([]);

  const handleScroll = (event) => {
    const sections = sectionRefs.current.filter(Boolean); // Filtra seções válidas
    const currentIndex = sections.findIndex(
      (section) => section.getBoundingClientRect().top >= -10
    );

    if (event.deltaY > 0 && currentIndex < sections.length - 1) {
      // Scroll para baixo
      sections[currentIndex + 1].scrollIntoView({ behavior: "smooth" });
    } else if (event.deltaY < 0 && currentIndex > 0) {
      // Scroll para cima
      sections[currentIndex - 1].scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <motion.div
        className="mt-3.5 relative z-10 h-screen flex flex-col items-center justify-center"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        onWheel={handleScroll}
        ref={(el) => (sectionRefs.current[0] = el)}
      >
        <h1 className="text-4xl pt-20 font-bold text-white bg-preto-suave bg-opacity-50 px-4 py-2 rounded-lg shadow-lg drop-shadow font-special">
          Bem-vindo ao <span className="text-verde-oliva bg-opacity-70 bg-white p-2">Challenge Game</span>
        </h1>
        <p className="bg-white font-bold text-lg mb-8 mt-16 bg-opacity-70 px-4 py-2 font-special text-preto-suave">
          Resolva desafios, ganhe moedas e conquiste seu lugar no ranking!
        </p>
        <Link to="/Login">
          <motion.button className="font-bold hover:backdrop-sepia px-6 py-3 transition drop-shadow font-special">
            Entrar no jogo
          </motion.button>
        </Link>
      </motion.div>

      {/* Features Section */}
      <motion.div
        className="h-screen flex flex-col items-center justify-center py-20 bg-black bg-opacity-50 backdrop-blur-sm text-white"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
        ref={(el) => (sectionRefs.current[1] = el)}
      >
        <h2 className="text-3xl font-bold text-center mb-6 font-special">Por que jogar?</h2>
        <div className="flex justify-center gap-8">
          <div className="text-center">
            <span className="block text-4xl mb-2">🏆</span>
            <p className="font-special">Suba no ranking semanal</p>
          </div>
          <div className="text-center">
            <span className="block text-4xl mb-2">💡</span>
            <p className="font-special">Desafie sua mente</p>
          </div>
          <div className="text-center">
            <span className="block text-4xl mb-2">🎁</span>
            <p className="font-special">Ganhe recompensas únicas</p>
          </div>
        </div>
      </motion.div>

      {/* Parallax Background */}
      <div
        className="relative bg-cover bg-fixed bg-preto-suave bg-opacity-50 h-screen"
        style={{ backgroundImage: `url(${backgroundImage})` }}
        ref={(el) => (sectionRefs.current[2] = el)}
      >
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <motion.div
          className="relative z-10 text-center py-20 flex flex-col items-center justify-center"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-3xl font-bold text-white mb-4">Pronto para começar?</h2>
          <Link to="/Register">
            <motion.button
              transition={{ delay: 0, duration: 0.3 }}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
              className="bg-dour-suave drop-shadow hover:bg-yellow-400 text-black px-6 py-3 rounded-full font-semibold transition"
            >
              Cadastre-se agora
            </motion.button>
          </Link>
          <div className="flex justify-center mt-40">
            <img src={personagens} className="w-auto" alt="Challenge Game" style={{ maxWidth: "550px" }} />
          </div>
        </motion.div>
      </div>

      <div
        className="py-16 text-center bg-indigo-700 h-screen flex flex-col items-center justify-center"
        ref={(el) => (sectionRefs.current[3] = el)}
      >
        <h2 className="text-3xl font-bold mb-4 text-white backdrop-blur-sm">
          Não perca tempo, o desafio te espera!
        </h2>
        <p className="text-lg text-white mb-8 backdrop-blur-sm">
          Jogue agora e aproveite os bônus especiais para novos jogadores!
        </p>
        <Link to="/Login">
          <button className="bg-verde-oliva hover:bg-verde-musgo text-black px-6 py-3 rounded-full font-semibold transition">
            Começar agora
          </button>
        </Link>
      </div>
    </>
  );
};

export default LandingPage;
